export default "__VITE_ASSET__DPQH412E__"